import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import { useTranslation } from "../utils/i18n";

const ICONS = [
  <StarOutlineIcon fontSize="large" />,
  <SchoolOutlinedIcon fontSize="large" />,
  <SupportAgentOutlinedIcon fontSize="large" />,
  <BuildOutlinedIcon fontSize="large" />,
];

function WhyUs() {
  const { translations } = useTranslation();
  const cards = translations.whyUs.cards;

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "70%" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        my: 10,
        px: { xs: 2, md: 0 },
      }}
    >
      <Box sx={{ textAlign: "center", mx: "auto" }}>
        <Typography
          variant="overline"
          sx={{ color: "rgba(255,255,255,0.6)", letterSpacing: 3 }}
        >
          {translations.whyUs.overline}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "2rem", md: "3.25rem" },
            mt: 2,
            mb: 6,
            lineHeight: 1.05,
            color: "white",
          }}
        >
          {translations.whyUs.title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(4, 1fr)",
          },
          width: "100%",
          pt: 2,
        }}
      >
        {cards.map((card, i) => (
          <Box
            key={card.title}
            sx={{
              textAlign: "center",
              px: 4,
              py: { xs: 3, md: 0 },
              borderRight: {
                md: i < cards.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
              },
              borderBottom: {
                xs: i < cards.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
                md: "none",
              },
            }}
          >
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                mx: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid rgba(255,255,255,0.08)",
                mb: 2,
                color: "#FF6A00",
              }}
            >
              {ICONS[i]}
            </Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 1, color: "white" }}
            >
              {card.title}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default WhyUs;
